import App from './app';
import React from 'react';
import {h, Fragment} from 'preact';
import {hydrate} from 'react-dom';
import {BrowserRouter} from 'react-router-dom';

// Grab the state from a global variable injected into the server-generated HTML
const context = window.APP_CONTEXT;

// Allow the passed state to be garbage-collected
delete window.APP_CONTEXT;

hydrate(
    <BrowserRouter>
        <App context={context} />
    </BrowserRouter>,
    document.getElementById('app')
);
